import { Assets, type Texture } from 'pixi.js';

/**
 * Lazy, memoized loader for the standalone table art (felt background + action/chip icons), copied
 * from Unity into public/img/. Loaded on table entry (not at boot) so the lobby stays light; Pixi's
 * Assets cache means each dev-multi iframe loads each file at most once.
 */

const NAMES = [
  'table',
  'board',
  'frame',
  'emblem',
  'checker-white-v2',
  'checker-black-v2',
  'checker-white-side-v2',
  'checker-black-side-v2',
  'hand',
  'stop',
  'reach',
  'chips',
] as const;
export type TableTexName = (typeof NAMES)[number];
export type TableTextures = Partial<Record<TableTexName, Texture>>;

let cache: Promise<TableTextures> | null = null;

export function loadTableTextures(): Promise<TableTextures> {
  if (!cache) {
    cache = (async () => {
      const out: TableTextures = {};
      await Promise.all(
        NAMES.map(async (n) => {
          try {
            out[n] = await Assets.load<Texture>(`/img/${n}.png`);
          } catch {
            // A missing texture just renders as an empty slot — never fatal.
          }
        }),
      );
      return out;
    })().catch((err: unknown) => {
      cache = null;
      throw err;
    });
  }
  return cache;
}
